import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isFeatureEnabled } from '../config/features';
import { Volleyball, Gear, Question, Sparkle, MapPin } from 'phosphor-react';
import './Drawer.css';

function Drawer({ isOpen, onClose, onSignIn }) {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  // "Real" sign-in = a Firebase user with a credential (Google /
  // email). Anonymous users don't count — for them, the drawer
  // shows "Sign In" so they can promote to a real account.
  const isSignedIn = !!user && !user.isAnonymous;

  const handleSignOut = async () => {
    try {
      await signOut();
      onClose();
    } catch (error) {
      console.error('Failed to sign out:', error);
    }
  };

  const handleSignIn = () => {
    onClose();
    if (onSignIn) onSignIn();
  };

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className={`drawer-backdrop ${isOpen ? 'open' : ''}`}
        onClick={handleBackdropClick}
        aria-hidden="true"
      />

      {/* Drawer */}
      <div className={`drawer ${isOpen ? 'open' : ''}`}>
        <div className="drawer-content">
          {/* User Profile Section */}
          <div className="drawer-profile">
            <div className="profile-avatar">
              {user?.photoURL ? (
                <img src={user.photoURL} alt="Profile" />
              ) : (
                <div className="avatar-placeholder">
                  {user?.email?.charAt(0).toUpperCase() || 'U'}
                </div>
              )}
            </div>
            <div className="profile-info">
              <div className="profile-name">
                {user?.displayName || user?.email || 'User'}
              </div>
            </div>
          </div>

          {/* Navigation Links */}
      <nav className="drawer-nav">
        <button className="drawer-nav-item" onClick={() => handleNavigation('/')}>
          <Volleyball size={24} weight="bold" className="nav-icon" />
          <span className="nav-label">Matches</span>
        </button>

        {isFeatureEnabled('GEO_BANNER', user) && (
          <button
            className="drawer-nav-item"
            onClick={() => handleNavigation('/nearby')}
          >
            <MapPin size={24} weight="bold" className="nav-icon" />
            <span className="nav-label">Matches near you</span>
          </button>
        )}

        {isFeatureEnabled('PAYMENTS', user) && (
          <button className="drawer-nav-item" onClick={() => handleNavigation('/upgrade')}>
            <Sparkle size={24} weight="bold" className="nav-icon" />
            <span className="nav-label">Subscription</span>
          </button>
        )}
        
        <button className="drawer-nav-item" onClick={() => handleNavigation('/settings')}>
          <Gear size={24} weight="bold" className="nav-icon" />
          <span className="nav-label">Settings</span>
        </button>
        
        <button className="drawer-nav-item" onClick={() => handleNavigation('/help')}>
          <Question size={24} weight="bold" className="nav-icon" />
          <span className="nav-label">Help & Support</span>
        </button>
      </nav>

          {/* Sign In / Sign Out — dynamic based on auth state. Anonymous
              users see "Sign In" since they can promote to real
              accounts; only credentialed users see "Sign Out." */}
          <div className="drawer-footer">
            {isSignedIn ? (
              <button className="drawer-signout" onClick={handleSignOut}>
                SIGN OUT
              </button>
            ) : (
              <button className="drawer-signout" onClick={handleSignIn}>
                SIGN IN
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Drawer;

